import { Collapse, useFormControl, useMediaQuery, type FormHelperTextProps } from '@mui/material';
import { useRef, useState } from 'react';
import { FieldHelpText } from '../../../../inputs/field/field-helper-text-caption';
import { useHoldLoginColumn } from '../login-column/use-hold-login-column';

/** A sign-in field's error line, opened and closed in place so only the content below it moves. */
export const RevealedFieldError = ({ children, id, className }: FormHelperTextProps) => {
  const error = useFormControl()?.error ?? false;
  const reduceMotion = useMediaQuery('(prefers-reduced-motion: reduce)');
  const [closed, setClosed] = useState(!error);
  if (error && closed) setClosed(false);
  useHoldLoginColumn(!closed);
  const lastMessage = useRef(children);
  if (error) lastMessage.current = children;

  return (
    <Collapse in={error} timeout={reduceMotion ? 0 : 'auto'} onExited={() => setClosed(true)}>
      {/* The field describes itself by this id, so a closing error must not still be read out. */}
      <FieldHelpText
        id={error ? id : undefined}
        className={className}
        ownerState={{ error: true }}
        wrap
      >
        {lastMessage.current}
      </FieldHelpText>
    </Collapse>
  );
};
